module.exports = __webpack_public_path__ + "static/media/account_circle.04675059.svg";